// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1drsR","imageUploader":"EGiftCard_imageUploader__3ZxRS"};